// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1AdsO","content":"RecentSearches_content__3DDCU"};